
import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  // Check if we're in Lovable editor environment
  const isLovableEditor = typeof window !== 'undefined' && (
    window.location.hostname.includes('lovable.app') ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('127.0.0.1') ||
    window.parent !== window // iframe detection
  );

  return (
    <footer className="bg-gradient-to-r from-amber-50 to-orange-100 border-t border-orange-200 mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="text-center space-y-4">
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
            <div className="text-sm text-gray-600">
              © VakantieUitzoeken.com {currentYear}
            </div>
            <Link 
              to="/contact" 
              className="text-orange-600 hover:text-orange-700 transition-colors text-sm"
            >
              Contact
            </Link>
            <Link 
              to="/privacy-cookiebeleid" 
              className="text-orange-600 hover:text-orange-700 transition-colors text-sm"
            >
              Privacy & Cookiebeleid
            </Link>
            <Link 
              to="/disclaimer" 
              className="text-orange-600 hover:text-orange-700 transition-colors text-sm"
            >
              Disclaimer
            </Link>
            {isLovableEditor && (
              <Link 
                to="/admin-analytics" 
                className="text-blue-600 hover:text-blue-700 transition-colors text-sm font-medium bg-blue-50 px-2 py-1 rounded"
              >
                📊 Analytics
              </Link>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
